module.exports = __webpack_public_path__ + "img/qr-wechat.2fa96e42.png";